<template>
  <div class="payback-wrapper">
    <el-dialog
      v-bind="dialogProps"
      width="720px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form
        v-loading="loading"
        ref="paybackForm"
        :model="formModel"
        label-width="120px"
        :rules="formRules"
      >
        <span>基础信息</span>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="回款类型:" prop="refundType">
              <el-select
                v-model="formModel.refundType"
                clearable
                placeholder="请选择回款类型"
              >
                <el-option
                  v-for="item in refundTypeList"
                  :key="item.uid"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回款金额(元):" prop="refundAmount">
              <el-input
                placeholder="请输入回款金额"
                v-model="formModel.refundAmount"
                @change="handleCheckAmountValue"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="回款日期:" prop="refundDate">
              <el-date-picker
                placeholder="请选择回款日期"
                v-model="formModel.refundDate"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回款期数:">
              <el-select
                v-model="formModel.refundInstallment"
                clearable
                placeholder="请选择回款期数"
                @change="handleRefundInstallmentChange"
              >
                <el-option
                  v-for="item in planList"
                  :key="item.id"
                  :label="item.refundInstallment"
                  :value="item.refundInstallment"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="计划回款金额(元):">
              <el-input
                v-model="formModel.planRefundAmount"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划回款日期:">
              <el-input
                v-model="formModel.planRefundDate"
                disabled
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称:" prop="customerName">
              <el-input v-model="formModel.customerName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务员:" prop="salesManName">
              <el-input v-model="formModel.salesManName" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="合同编号:" prop="contractNumber" required>
              <el-input v-model="formModel.contractNumber" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同金额(元):" prop="contractAmount">
              <el-input v-model="formModel.contractAmount" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="我方收款公司:" prop="myReceivableCompany">
              <el-select
                v-model="formModel.myReceivableCompany"
                clearable
                filterable
                placeholder="请选择我方收款公司"
                @change="handleChangeCompany"
              >
                <el-option
                  v-for="item in myReceivableCompanyList"
                  :key="item.myReceivableCompanyCode"
                  :label="item.myReceivableCompanyName"
                  :value="item.myReceivableCompanyCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="我方收款银行:" prop="myReceivableBank">
              <el-select
                v-model="formModel.myReceivableBank"
                clearable
                filterable
                placeholder="请选择我方收款银行"
                @change="handleBankChange"
              >
                <el-option
                  v-for="item in myReceivableBankList"
                  :key="item.myReceivableBankId"
                  :label="item.myReceivableBankName"
                  :value="item.myReceivableBankId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="我方收款账号:" prop="myReceivableAccount">
              <el-select
                v-model="formModel.myReceivableAccount"
                clearable
                filterable
                placeholder="请选择我方收款账号"
              >
                <el-option
                  v-for="item in myReceivableAccountList"
                  :key="item.myReceivableAccountId"
                  :label="item.myReceivableAccountName"
                  :value="item.myReceivableAccountId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="一级结算部门:" prop="firstAccountDept">
              <el-input v-model="formModel.firstAccountDept" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <span>补充信息</span>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="最小预算单元:" prop="">
              <el-select
                v-model="formModel.minimumBudgetUnit"
                clearable
                filterable
                placeholder="请选择预算单元"
                @change="handleSettlementChange"
              >
                <el-option
                  v-for="item in minimumBudgetUnitList"
                  :key="item.uid"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务结算单元:" prop="">
              <el-cascader
                v-model="formModel.businessAccountDept"
                :options="deptOptions"
                :props="{
                  children: 'childrenDept',
                  label: 'departmentName',
                  value: 'departmentId',
                }"
                filterable
                clearable
                @change="handleChangeDept"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="客户打款银行:" prop="customerPayBank">
              <el-input
                v-model="formModel.customerPayBank"
                maxlength="100"
                placeholder="请输入准确的银行名称"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户银行账号:" prop="customerPayAccount">
              <el-input
                v-model="formModel.customerPayAccount"
                placeholder="请输入客户银行账号"
                type="number"
                oninput="if(value.length > 30) value=value.slice(0, 30)"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="备注:" prop="remark">
              <el-input
                v-model="formModel.remark"
                type="textarea"
                :rows="5"
                style="width: 200px;"
                maxlength="400"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="附件:" prop="files">
              <el-upload
                ref="upload"
                class="upload-demo"
                action="action"
                accept=".jpg,.jpeg,.png,.pdf,.bmp,.doc"
                :http-request="handleUpdate"
                :before-upload="beforeAvatarUpload"
                :on-success="handleOnSuccess"
                :file-list="uploadList"
                :limit="5"
                :on-exceed="handleExceed"
                :before-remove="handleRemove"
              >
                <crm-button :text="'上传'"></crm-button>
                <div
                  slot="tip"
                  class="el-upload__tip"
                  style="word-break: normal"
                >
                  说明:仅支持文件格式：jpg、png、bmp、pdf、word,文件大小不得超过20M
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="dialogProps.mode === 'edit'">
          <el-col :span="12">
            <el-form-item label="状态:">
              <span>{{ formModel.examineStatus }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回单:">
                <el-button type="text" @click="handlePreviewUrl(formModel.receiptLink)">
                    回单
                </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="plain" @click="handleClose(true)">关闭</el-button>
          <el-button type="primary" @click="handleSubmit()">确定</el-button>
        </span>
      </template>
      <pdf-view ref="pdfView"/>
    </el-dialog>
  </div>
</template>

<script>
const MODE = ['add', 'edit'];
const TITLE = ['新增回款记录', ' 编辑回款记录'];

import crmButton from '~component/base/crmButton';
import services from '~api/compact';
import servicesInside from '~api/compact-inside';
import pdfView from "@/components/base/pdf-view";
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    crmButton,
    pdfView,
  },
  props: {
    row: {},
    id: String,
    info: Object,
  },
  data() {
    const checkAmountRule = (rule, value, callback) => {
      const reg = /^([1-9]\d*(\.\d{1,2})?|([0](\.([0][1-9]|[1-9]\d{0,1}))))$/;
      if (!reg.test(value)) {
        callback(new Error('请输入最多两位小数的数字'));
      } else if (value > 999999999999.99) {
        callback(new Error('最多十二位数'));
      } else {
        callback();
      }
    };
    const checkCustomerBankName = (rule, value, callback) => {
      if (value) {
        const reg = /^[\u4E00-\u9FA5A-Za-z\(\)\（\）]+$/;
        if (!reg.test(value)) {
          callback(new Error('客户银行仅支持输入中英文及括号'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      authority: null,
      loading: false,
      deptOptions: [],
      dialogProps: {
        visible: false,
        mode: null,
        title: null,
      },
      formRules: {
        refundType: [
          {
            required: true,
            message: '请选择回款类型',
            trigger: ['blur', 'change'],
          },
        ],
        refundAmount: [
          { required: true, message: '请输入回款金额', trigger: 'blur' },
          {
            required: true,
            validator: checkAmountRule.bind(this),
            trigger: ['change', 'blur'],
          },
        ],
        refundDate: [
          { required: true, message: '请选择回款时间', trigger: 'blur' },
        ],
        customerName: [
          {
            required: true,
            message: '请选择回款客户',
            trigger: ['blur', 'change'],
          },
        ],
        customerPayBank: [
          { required: false, message: '请输入客户打款银行', trigger: ['blur'] },
          {
            required: false,
            validator: checkCustomerBankName.bind(this),
            trigger: ['change', 'blur'],
          },
        ],
        customerPayAccount: [
          { required: false, message: '请输入客户银行账号', trigger: 'blur' },
        ],
        myReceivableBank: [
          {
            required: true,
            message: '请选择我方收款银行',
            trigger: ['blur', 'change'],
          },
        ],
        myReceivableAccount: [
          {
            required: true,
            message: '请选择我方收款银行账号',
            trigger: ['blur', 'change'],
          },
        ],
        myReceivableCompany: [
          {
            required: true,
            message: '请选择我方收款公司',
            trigger: ['blur', 'change'],
          },
        ],
        minimumBudgetUnit: [
          {
            required: true,
            message: '请选择最小预算单元',
            trigger: ['blur', 'change'],
          },
        ],
        firstAccountDept: [
          {
            required: false,
            message: '请根据预算单元获取结算部门',
            trigger: ['blur', 'change'],
          },
        ],
        businessAccountDept: [
          {
            required: true,
            message: '请选择业务结算部门',
            trigger: ['blur', 'change'],
          },
        ],
      },
      formModel: {
        refundType: null,
        refundAmount: null,
        refundDate: null,
        refundInstallment: '',
        customerName: null,
        customerId: null,
        salesManName: null,
        salesmanCode: null,
        customerPayBank: null,
        customerPayAccount: null,
        myReceivableCompany: null,
        myReceivableBank: null,
        myReceivableAccount: null,
        contractNumber: null,
        contractAmount: null,
        minimumBudgetUnit: null,
        firstAccountDept: null,
        businessAccountDept: [],
        teamId: null,
        remark: null,
        files: [],
        planRefundAmount: null,
        planRefundDate: null,
        receivablePlanId: null,
      },
      userTeam: null,
      uploadList: [],
      refundTypeList: [],
      myReceivableBankList: [],
      myReceivableAccountList: [],
      myReceivableCompanyList: [],
      minimumBudgetUnitList: [],
      planList: [],
    };
  },
  watch: {
    'dialogProps.visible': {
      async handler(value) {
        if (value) {
          await this.handleInitData();
          await this.handleGetPlanList();
          if (this.dialogProps.mode === 'edit') {
            this.$nextTick(() => {
              this.myReceivableBankList = this.myReceivableCompanyList.find(
                item =>
                  item.myReceivableCompanyCode === this.formModel.myReceivableCompany,
              ).bankList;
              this.myReceivableAccountList = this.myReceivableBankList.find(
                item =>
                  item.myReceivableBankId === this.formModel.myReceivableBank,
              ).accountList;
            });
          } else {
            // "我方收款公司"默认项
            this.handleInitMyReceivableCompany();
            this.formModel.customerName = this.info.customerName
            this.formModel.salesManName = this.info.salesmanName
            this.formModel.contractNumber = this.info.contractNo
            this.formModel.contractAmount = this.info.contractAmountStr
            this.formModel.customerId = this.info.customerId
            this.formModel.refundInstallment = ''
            // 获取业务结算部门
            if (this.compactDetail.fycdbm) {
              const nameArr = this.compactDetail.fycdbm.split('/')
              const ids = []
              function getId(name, arr, nameList) {
                arr.forEach(it => {
                  if (it.departmentName === name) {
                    ids.push(it.departmentId)
                    nameList.shift() // nameList删掉一个
                    if (nameList.length && it.childrenDept.length) {
                      getId(nameList[0], it.childrenDept, nameList)
                    }
                  }
                })
              }
              getId(nameArr[0], this.deptOptions, nameArr)
              this.formModel.businessAccountDept = ids[ids.length - 1]
            }
            // 最小预算单元
            if (this.compactDetail.zxysdy) {
              const item = this.minimumBudgetUnitList.find(it => it.name === this.compactDetail.zxysdy)
              if (item) {
                this.formModel.minimumBudgetUnit = item.uid
                this.handleSettlementChange(item.uid)
              }
            }
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      compactDetail: "compact/compactDetail",
    }),
  },
  mounted() {
    this.handleGetRefundTypeList()
  },
  methods: {
    async handleInitData() {
      try {
        this.loading = true;
        if (!this.myReceivableCompanyList.length) {
          await this.handleGetBankInfo();
          await this.handleGetBudgetUnitInfo();
          await this.handleGetDept();
        } else {
          this.formModel.businessAccountDept = this.userTeam;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 我发收款公司默认项
    handleInitMyReceivableCompany() {
      const item = this.myReceivableCompanyList.find(ele => ele.myReceivableCompanyName === this.compactDetail.wfqyzt)
      if (item) {
        this.formModel.myReceivableCompany = item.myReceivableCompanyCode
        this.handleChangeCompany(item.myReceivableCompanyCode)
      }
    },
    async handleGetDept() {
      const { data } = await services.apiGetAllDept();
      this.deptOptions = this.handleInitTreeData(data.data);
      const res = await services.apiGetUserDept();
      this.userTeam = res.data.departmentId;
      this.formModel.businessAccountDept = this.userTeam;
    },
    async handleGetBankInfo() {
      const { data } = await services.apiGetMyBankInfo();
      this.myReceivableCompanyList = data.data;
    },
    async handleGetBudgetUnitInfo() {
      const { data } = await services.apiGetBudgetUnit();
      this.minimumBudgetUnitList = data.data;
    },
    handleInitTreeData(arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        arr.forEach((item) => {
          if (item.childrenDept.length === 0) {
            delete item.childrenDept;
          }
          this.handleInitTreeData(item.childrenDept);
        });
      }
      return arr;
    },
    handleChangeCompany(val) {
      if (val !== '') {
        this.myReceivableBankList = this.myReceivableCompanyList.find(
          item => item.myReceivableCompanyCode === val,
        ).bankList;
        this.formModel.myReceivableBank = null;
        this.formModel.myReceivableAccount = null;
      } else {
        this.myReceivableBankList = null;
        this.myReceivableAccountList = null;
        this.formModel.myReceivableBank = null;
        this.formModel.myReceivableAccount = null;
      }
    },
    handleBankChange(val) {
      if (val !== '') {
        this.myReceivableAccountList = this.myReceivableBankList.find(
          item => item.myReceivableBankId === val,
        ).accountList;
        this.formModel.myReceivableAccount = null;
      } else {
        this.myReceivableAccountList = null;
        this.formModel.myReceivableAccount = null;
      }
    },
    handleSettlementChange(val) {
      if (val !== '') {
        const target = this.minimumBudgetUnitList.find(
          item => item.uid === val,
        );
        this.formModel.firstAccountDept = target.settlementDeptName;
        this.formModel.firstAccountDeptId = target.settlementDeptId;
      }
    },
    handleChangeDept(val) {
      if (val) {
        this.formModel.businessAccountDept = val[val.length - 1];
      }
    },
    async handleUpdate(item) {
      // 上传
      const params = new FormData();
      params.append('file', item.file);
      params.append('fileName', item.file.name);
      try {
        const res = await services.apiUploadFile(params);
        this.$message.success('上传成功');
        this.formModel.files.push(res.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    beforeAvatarUpload(file) {
      // 检查文件大小 20M
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!');
        this.uploadList = [];
      }
      return isLt20M;
    },
    handleOnSuccess(response, file, fileList) {
      this.uploadList = fileList;
    },
    // eslint-disable-next-line consistent-return
    handleRemove(file, fileList) {
      const delIndex = this.uploadList.findIndex(item => item.uid === file.uid);
      // 删除
      if (file && file.status === 'success') {
        this.$confirm(`确定移除 ${file.name}？`)
          .then(() => {
            this.formModel.files.splice(delIndex, 1);
            this.uploadList.splice(delIndex, 1);
          })
          .catch((error) => {
            console.log(error);
            this.$message.info('取消操作');
          });
        return false;
      }
    },
    handleExceed() {
      this.$message.error('最多支持上传5个文件');
    },
    handleOpen() {
      this.formModel = Object.assign(this.formModel, {
        contractId: this.row.id || this.id, // 新增的时候，row里面没有id
        contractNumber: this.row.contractNo,
        contractAmount: this.row.contractAmount,
        customerName: this.row.customerName,
        customerId: this.row.customerId,
        salesmanCode: this.row.salesmanCode,
        salesManName: this.row.userName,
        teamId: this.row.teamId,
        businessAccountDept: this.userTeam,
      });
      this.dialogProps = {
        visible: true,
        mode: MODE[0],
        title: TITLE[0],
      };
    },

    handleEdit(row) {
      this.dialogProps = {
        visible: true,
        mode: MODE[1],
        title: TITLE[1],
      };
      this.$nextTick(() => {
        const {
          id,
          contractNo,
          refundTypeCode,
          myReceivableCompanyId,
          myReceivableBankId,
          myReceivableAccountId,
          minimumBudgetUnitId,
          businessAccountDeptId,
          fileList,
          salesmanName,
          salesmanCode,
          refundInstallment,
          planRefundAmount,
          planRefundDate,
          ...rest
        } = row;
        this.formModel = Object.assign(this.formModel, rest, {
          id,
          contractNumber: contractNo,
          refundType: refundTypeCode,
          refundInstallment: refundInstallment === 0 ? '' : refundInstallment,
          myReceivableCompany: myReceivableCompanyId,
          myReceivableBank: myReceivableBankId,
          myReceivableAccount: myReceivableAccountId,
          minimumBudgetUnit: minimumBudgetUnitId,
          businessAccountDept: businessAccountDeptId,
          salesManName: salesmanName,
          planRefundAmount,
          planRefundDate,
          salesmanCode,
          files: fileList.length > 0 ? fileList.map(item => item.id) : [],
        });
        fileList.forEach((item) => {
          this.uploadList.push({
            url: item.fileUrl,
            name: item.fileName,
          });
        });
      });
    },

    async handleSubmit() {
      try {
        await this.$refs.paybackForm.validate();
        this.$confirm(
          '当前操作将提交回款申请至财务侧核对、确认，提交后不可撤回，是否继续？',
          '提交确认',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(async () => {
          if (this.dialogProps.mode === 'add') {
            await services.apiAddPayback({
              contractId: this.contractId,
              ...this.formModel,
              businessAccountDept: this.formModel.businessAccountDept || '',
            });
          } else {
            await services.apiEditPayback({
              contractId: this.contractId,
              ...this.formModel,
              businessAccountDept: this.formModel.businessAccountDept || '',
            });
          }
          this.$message.success('操作成功');
          this.$emit('handle-success-payback');
          this.handleClose();
        });
      } catch (error) {
        console.log(error);
      }
    },

    handleClose(isClick = false) {
      if (isClick) {
        this.$confirm(
          '当前操作将关闭该弹窗，编辑内容将丢失，是否继续？',
          '提交提醒',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(async () => {
          this.handleReset();
        });
      } else {
        this.handleReset();
      }
    },
    handleReset() {
      this.$refs.paybackForm.resetFields();
      this.formModel.businessAccountDept = [];
      this.formModel.files = [];
      this.formModel.planRefundAmount = ''
      this.formModel.planRefundDate = ''
      this.uploadList = [];
      this.dialogProps = {
        visible: false,
        mode: MODE[0],
        title: TITLE[0],
      };
    },
    // 获取回款类型字典
    async handleGetRefundTypeList() {
      const { data } = await services.apiGetCategoryData({ code: 'category_refund_type' })
      this.refundTypeList = data.results
    },
    async handleGetPlanList() {
      const { data } = await services.apiQueryPlanList({
        contractId: this.id,
      })
      this.planList = data.data
    },
    // 回款期数选择
    handleRefundInstallmentChange(value) {
      const item = this.planList.find(ele => ele.refundInstallment === value)
      this.formModel.planRefundAmount = item ? item.planRefundAmount : ''
      this.formModel.planRefundDate = item ? item.planRefundDate : ''
      this.formModel.receivablePlanId = item ? item.id : ''
      this.handleCheckAmount(value)
    },
    async handleCheckAmount(value) {
      if (!value || !this.formModel.refundAmount) return
      const item = this.planList.find(ele => ele.refundInstallment === value)
      const { data } = await servicesInside.apiGetContractShiftRecord({
        id: item.id,
        receivableAmount: this.formModel.refundAmount,
      });
      if (!data.data) { // 没校验通过
        this.$message.error('同一回款计划的回款总金额不得超过计划回款金额！');
        this.formModel.refundAmount = ''
      }
    },
    async handleCheckAmountValue(value) {
      if (!value || !this.formModel.refundInstallment) return
      const item = this.planList.find(ele => ele.refundInstallment === this.formModel.refundInstallment)
      const { data } = await servicesInside.apiGetContractShiftRecord({
        id: item.id,
        receivableAmount: value,
      });
      if (!data.data) { // 没校验通过
        this.$message.error('同一回款计划的回款总金额不得超过计划回款金额！');
        this.formModel.refundAmount = ''
      }
    },
    handlePreviewUrl(url) {
        this.$refs.pdfView.open(url)
    },
  },
};
</script>

<style scoped lang="less"></style>
